export const RECEIVE_QUESTIONS = 'questions/RECEIVE';
export const ANSWER_QUESTION = 'questions/ANSWER';
export const RESET_QUESTION = 'questions/RESET';
export const ADD_QUESTION = 'questions/ADD';
